import React, { FunctionComponent } from "react";

import { TirePartItem } from "../../../../queries/useSearchTiresByVehicle";
import { WheelPartItem } from "../../../../queries/useSearchWheelsByVehicle";
import { PriceDisplay } from "../../../../ui/PriceDisplay/PriceDisplay";

export const PartPrice: FunctionComponent<{
  part: TirePartItem | WheelPartItem;
  quantity: number;
}> = ({ part, quantity }) => {
  const price =
    part.partPricing.primaryPart.price[quantity]?.contextList[0].displayPrice;

  return <PriceDisplay>{price}</PriceDisplay>;
};
